export default __webpack_public_path__ + "static/media/101_background.c8297d6a.gif";